module.exports = __webpack_public_path__ + "static/media/MobileCardStatement.4907b159.png";